import { type PropsWithChildren } from "react";

interface Props {
  title: string;
}

export const TopNav = ({ title, children }: PropsWithChildren<Props>) => {
  return (
    <div className="flex items-center gap-8">
      <div className="text-lg text-v2-primary font-bold flex items-center mb-2.5">
        {title}
      </div>
      <div className="flex items-center gap-6">{children}</div>
    </div>
  );
};
